import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { INoteData } from "common/records/Note";

export const RECEIVE_NOTE = "@note/RECEIVE_NOTE";
export const RECEIVE_NOTES = "@note/RECEIVE_NOTES";
export const REMOVE_NOTE = "@note/REMOVE_NOTE";
export const RESET_NOTE = "@note/RESET_NOTE";

export const NoteActions = {
  receiveNote: (note: Partial<INoteData>) => createAction(RECEIVE_NOTE, note),
  receiveNotes: (notes: INoteData[]) => createAction(RECEIVE_NOTES, { notes }),
  removeNote: (noteId: number) => createAction(REMOVE_NOTE, { noteId }),
  resetNote: (noteId: number) => createAction(RESET_NOTE, { noteId }),
};

export type NoteActions = ActionsUnion<typeof NoteActions>;
